import { showToast } from "../../helpers/utils/Utils";
import { tgxApi } from "../../app/tgxApi";
import { handleQueryError } from "../../helpers/utils/RtkQueryUtils";

export const CUSTOMER_DISABLED_MESSAGE = "User customer has been disabled!";

const loginPageApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        loginUser: build.mutation({
            query: (request) => {
                const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.replaceAll('/', '&');
                return {
                    url: `/ajax/authenticate/${timeZone}`,
                    method: "POST",
                    body: request,
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                try {
                    const res = await queryFulfilled;
                    const result = res?.data;
                    const token = result?.customAuthTokenDTO?.token;
                    if (result?.success !== true || result?.errorCode !== 200 || !token) {
                        localStorage.clear();
                        return;
                    }

                    localStorage.setItem('user', 'loggedIn');
                    localStorage.setItem("daysToExpirePassword", JSON.stringify(result?.daysToExpirePassword));
                    localStorage.setItem('authToken', token);

                    if (result?.customAuthTokenDTO?.isUserHaveTeam !== null) {
                        localStorage.setItem(
                            "isUserHaveTeam",
                            JSON.stringify(result?.customAuthTokenDTO?.userHaveTeam)
                        );
                    }

                    localStorage.setItem(
                        "isUserManager",
                        JSON.stringify(result?.customAuthTokenDTO?.isUserManager)
                    );
                } catch (error: any) {
                    if (error?.error?.data?.message !== CUSTOMER_DISABLED_MESSAGE) {
                        showToast(error?.error?.data?.message || "Login failed", "error");
                    }
                    localStorage.clear();
                }
            },
        }),

        baseUrl: build.query({
            query: (url) => {
                return {
                    url: `/ajax/base-url`,
                    method: 'GET',
                    headers: {
                        'X-Tenant-Url': url
                    }
                };
            },
            providesTags: ["baseUrl"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled);
            },
        }),

    })
})
export const {
    useLoginUserMutation,
    useBaseUrlQuery
} = loginPageApi;
